(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dsc-campaign-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dsc-campaign-slider')) {
  customElements.define('dsc-campaign-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dsc-campaign-track');
      this.slides = [...this.querySelectorAll('.dsc-campaign-slide')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paused = this.dataset.autoplay !== 'true' || this.reduced;
      this.index = 0;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.querySelector('[data-prev]').addEventListener('click',()=>{this.stop();this.go(this.index-1);},opts);
      this.querySelector('[data-next]').addEventListener('click',()=>{this.stop();this.go(this.index+1);},opts);
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.stop();this.go(i);},opts));
      this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.refresh();},opts);
      this.track.addEventListener('pointerdown',()=>this.stop(),opts);
      this.track.addEventListener('focusin',()=>this.stop(),opts);
      this.track.addEventListener('scroll',()=>{
        this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);
        this.dots.forEach((dot,i)=>i===this.index?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));
      },opts);
      this.addEventListener('mouseenter',()=>clearInterval(this.timer),opts);
      this.addEventListener('mouseleave',()=>this.refresh(),opts);
      document.addEventListener('visibilitychange',()=>this.refresh(),opts);
      this.refresh();
    }
    go(i) {
      const n=(i+this.slides.length)%this.slides.length;
      this.track.scrollTo({left:n*this.track.clientWidth,behavior:this.reduced?'instant':'smooth'});
    }
    stop() {this.paused=true;this.refresh();}
    refresh() {
      clearInterval(this.timer);
      this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause;
      if(!this.paused&&!document.hidden&&this.slides.length>1) this.timer=setInterval(()=>this.go(this.index+1),7000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsc-header"] && !Shopify.designMode) return;
  try {
    
function initializeDSCSearch(root) {
  root.querySelectorAll('.dsc-header-search').forEach(details=>{
    if(details.dataset.ready)return;
    details.dataset.ready='true';
    details.addEventListener('toggle',()=>{
      if(details.open){
        const header=details.closest('.dsc-header');
        header.querySelectorAll('details[open]').forEach(other=>{if(other!==details)other.open=false;});
        details.querySelector('input[type=search]')?.focus();
      }
    });
    details.addEventListener('keydown',event=>{
      if(event.key==='Escape'){details.open=false;details.querySelector('summary').focus();}
    });
  });
}
initializeDSCSearch(document);
document.addEventListener('shopify:section:load',event=>initializeDSCSearch(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsc-product-carousel"] && !Shopify.designMode) return;
  try {
    
function initTrouserTracks(){document.querySelectorAll('.dsc-trouser-carousel').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const track=root.querySelector('.dsc-trouser-track');root.querySelectorAll('[data-trouser-step]').forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.dsc-wb-card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:(card.getBoundingClientRect().width+gap)*Number(button.dataset.trouserStep),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}))})}initTrouserTracks();document.addEventListener('shopify:section:load',initTrouserTracks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsc-signature-home"] && !Shopify.designMode) return;
  try {
    
function initDSCarousels(){document.querySelectorAll('[data-ds-carousel]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='1';
const track=root.querySelector('[data-ds-track]'),slides=[...root.querySelectorAll('[data-ds-slide]')],dots=[...root.querySelectorAll('[data-ds-dot]')];let active=0,frame;
const sync=()=>{active=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));dots.forEach((d,i)=>{if(i===active)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')})};
const show=n=>{const index=(n+slides.length)%slides.length;track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
dots.forEach((d,i)=>d.addEventListener('click',()=>show(i)));root.querySelector('[data-ds-prev]').addEventListener('click',()=>show(active-1));root.querySelector('[data-ds-next]').addEventListener('click',()=>show(active+1));
track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(sync)},{passive:true});
root.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1))}});
track.addEventListener('dragstart',e=>e.preventDefault());
})}initDSCarousels();document.addEventListener('shopify:section:load',initDSCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsc-terry-bundle"] && !Shopify.designMode) return;
  try {
    
function initDscBundles() {
  document.querySelectorAll('[data-bundle-section]').forEach(root => {
    if (root.dataset.bundleReady) return;
    root.dataset.bundleReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-bundle-labels]').textContent);
    const list = root.querySelector('[data-bundle-list]');
    const status = root.querySelector('[data-bundle-status]');
    const checkouts = [...root.querySelectorAll('[data-bundle-checkout]')];
    const dock = root.querySelector('[data-bundle-dock]');
    const key = 'dsc-terry-bundle-v2';
    const options = new Map([...root.querySelectorAll('[data-bundle-variant] option:not(:disabled)')].map(o => [Number(o.value), o.dataset.title]));
    let picked = [], busy = false;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
      if (Array.isArray(saved)) picked = saved.filter(x => options.has(Number(x.id))).slice(0,3).map(x => ({id:Number(x.id),title:options.get(Number(x.id))}));
    } catch (error) {}
    function message(value) { status.textContent = value; }
    function render() {
      list.replaceChildren();
      picked.forEach((item,i) => {
        const li = document.createElement('li');
        li.append(document.createTextNode(item.title));
        const remove = document.createElement('button');
        remove.type = 'button'; remove.textContent = labels.remove; remove.disabled = busy;
        remove.setAttribute('aria-label', labels.remove + ' ' + item.title);
        remove.onclick = () => { picked.splice(i,1); message(''); render(); };
        li.append(remove); list.append(li);
      });
      root.querySelector('[data-bundle-count]').textContent = picked.length + ' / 3';
      root.querySelector('[data-bundle-progress]').textContent = picked.length + ' / 3 — ' + (picked.length === 3 ? labels.full : labels.progress);
      dock.hidden = picked.length === 0;
      root.dataset.hasSelection = String(picked.length > 0);
      checkouts.forEach(button => {
        button.disabled = picked.length !== 3 || busy;
        button.textContent = busy ? labels.adding : picked.length === 3 ? labels.checkout : labels.remaining.replace('[count]', String(3-picked.length));
      });
      root.querySelectorAll('[data-bundle-add]').forEach(button => {
        const option = button.parentElement.querySelector('select').selectedOptions[0];
        button.disabled = busy || picked.length === 3 || !option || option.disabled;
      });
      root.querySelectorAll('[data-bundle-variant]').forEach(select => select.disabled = busy);
      try { sessionStorage.setItem(key, JSON.stringify(picked)); } catch (error) {}
    }
    root.querySelectorAll('[data-bundle-variant]').forEach(select => select.addEventListener('change', render));
    root.querySelectorAll('[data-bundle-add]').forEach(button => button.onclick = () => {
      if (busy || picked.length >= 3) return;
      const card = button.parentElement, option = card.querySelector('select').selectedOptions[0];
      if (!option || option.disabled) { message(labels.unavailable); return; }
      picked.push({id:Number(option.value), title:option.dataset.title});
      root.querySelectorAll('[data-bundle-feedback]').forEach(node => node.textContent = '');
      card.querySelector('[data-bundle-feedback]').textContent = labels.added + ' — ' + picked.length + ' / 3';
      message(picked.length === 3 ? labels.full : labels.progress);
      render();
    });
    root.querySelectorAll('[data-bundle-start],[data-bundle-review]').forEach(link => link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior:'smooth',block:'start'});
      if (link.hasAttribute('data-bundle-review')) target.focus({preventScroll:true});
    }));
    const addBundle = async () => {
      if (picked.length !== 3 || busy) return;
      busy = true; render(); message(labels.adding);
      const grouped = new Map();
      picked.forEach(item => grouped.set(item.id, (grouped.get(item.id) || 0) + 1));
      const route = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(route + 'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...grouped].map(([id,quantity]) => ({id,quantity}))})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || labels.error);
        try { sessionStorage.removeItem(key); } catch (error) {}
        window.location.assign(route + 'cart');
      } catch (error) {
        busy = false; render(); message(error.message || labels.error);
        root.querySelector('.dsc-bundle__basket').scrollIntoView({behavior:'smooth',block:'center'});
      }
    };
    checkouts.forEach(button => button.onclick = addBundle);
    render();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initDscBundles);
else initDscBundles();
document.addEventListener('shopify:section:load',initDscBundles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
